import { render, staticRenderFns } from "./recuperar-senha.vue?vue&type=template&id=9c48f0e0&"
import script from "./recuperar-senha.vue?vue&type=script&lang=js&"
export * from "./recuperar-senha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports